import { doc, getDoc } from 'firebase/firestore';

import { FSCollections } from '@src/constants/database';
import { db } from '@src/firebase/firebase';
import Company from '@src/models/Company';
import { getDocData } from '@src/packages/utils';
import { createOperation } from '@src/util/firebase-operations/utils/createOperation';
import safeExecute from '@src/util/safeExecute';

class CompanyRepository {
  constructor() {
    this.companiesCollection = FSCollections.COMPANIES;
    this.organizationCollection = FSCollections.ORGANIZATIONS;
    this.company = new Company();
  }

  getCompaniesPath(orgId) {
    return `${this.organizationCollection}/${orgId}/${this.companiesCollection}`;
  }

  async create(data) {
    return safeExecute(async () => {
      const collectionName = this.getCompaniesPath(data?.organizationId);
      this.company.setData(data);
      const res = await createOperation(collectionName, null, this.company, 'create');

      return res;
    });
  }

  async update(data) {
    return safeExecute(async () => {
      const collectionName = this.getCompaniesPath(data.organizationId);
      this.company.setData(data);
      const companyToBeUpdated = this.company.toUpdate();
      const res = await createOperation(collectionName, data.id, companyToBeUpdated, 'update');

      return res;
    });
  }

  async delete({ organizationId, companyId }) {
    return safeExecute(async () => {
      const collectionName = this.getCompaniesPath(organizationId);
      await createOperation(collectionName, companyId, null, 'delete');
    });
  }

  async getCompany({ organizationId, companyId }) {
    return safeExecute(async () => {
      const companyRef = doc(db, `${this.getCompaniesPath(organizationId)}/${companyId}`);
      const docSnap = await getDoc(companyRef);
      const companyData = getDocData(docSnap);

      return companyData;
    });
  }
}

export default CompanyRepository;
